export default __webpack_public_path__ + "static/media/SuperToDo2.5472f757.jpg";